module.exports = __webpack_public_path__ + "img/popeye3.aff5f96f.jpg";